'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.monthly_demand_report', {
        template: '<monthly-demand-report></monthly-demand-report>'
    });
}



// WEBPACK FOOTER //
// ./public/dev/app/demand_report/monthly/monthly_demand_report.routes.js